// extracted by mini-css-extract-plugin
export default {"wrapper":"create-page-link_wrapper--Ccxu7","linkBox":"create-page-link_linkBox--jQQdy","copy":"create-page-link_copy--sjz1B"};